export default __webpack_public_path__ + "static/media/soft-serve.13388d97.svg";